import {Config} from '../utils/Config'

const translation = {
  getTranslationsForText: () => `/Translation/tranlate`,
}

const themes = {
  getCustomerThemes: (schoolId, matId) =>
    `/theme/getCustomerThemes?schoolId=${schoolId}&matId=${matId}`,
  getSurveyThemes: (id, schoolId, matId) =>
    `/theme/getSurveyThemes?id=${id}&schoolId=${schoolId}&matId=${matId}`,
  updateSurveyThemes: () => `/theme/updateSurveyThemes`,
}

//////////survey  api

const survey = {
  surveys: () => `/survey`,
  UpdateAnonymousShareSettings: (anonyous, share) =>
    `/survey/UpdateAnonymousShareSettings?anonyous=${anonyous}&share=${share}`,
  get: () => `/survey/GetByToken`,
  getAll: (cId, cType, limit) =>
    `/survey/GetAll?customerId=${cId}&customerType=${cType}&limit=${limit}`,
  submit: lang => `/survey/SubmitSurvey?lang=${lang}`,
  updateParticipants: () => `/survey/UpdateParticipants`,
  getSurveyForResults: (schoolId, matId) =>
    `/survey/getSurveyForResults?schoolId=${schoolId}&matId=${matId}`,
  delete: () => `/survey/delete`,
  resendInvites: () => `/survey/resendInvites`,
  UpdateSurveyAnnonymise: () => `/survey/UpdateSurveyAnnonymise`,
  getParticipationBreakdown: id =>
    `/survey/GetParticipationBreakdown?surveyId=${id}`,
  getParticipationBreakdownBySchool: (groupId, schoolId, surveyId) =>
    `/survey/getParticipationBreakdownBySchool?groupId=${groupId}&schoolId=${schoolId}&surveyId=${surveyId}`,
  getPupilSurveys: (schoolId, studentId) =>
    `/survey/getPupilSurveys?schoolId=${schoolId}&studentId=${studentId}`,
  getSchoolsofMatSurveys: id => `/survey/getSchoolsofMatSurveys?matId=${id}`,
  getMatSurveysForSchool: (mId, sId) =>
    `/survey/GetMatSurveysForSchool?matId=${mId}&schoolId=${sId}`,
  getSurveyStatus: id => `/survey/getSurveyStatus?id=${id}`,
  GetSurveyForReviewByToken: () => `/survey/GetSurveyForReviewByToken`,
  getSurveyParticipationFilters: () => `/survey/GetSurveyParticipationFilters`,
  addUpdateParticipantFilter: () => `/survey/AddUpdateParticipantFilter`,
  UpdateLiveSurveyEndDate: () => `/survey/UpdateLiveSurveyEndDate`,
  getUnassignedSchools: token =>
    `/survey/GetUnassignedSchools?token=${encodeURIComponent(token)}`,
  addSchoolsToLiveSurvey: () => `/survey/AddSchoolsToLiveSurvey`,
}

const scheduler = {
  canPublish: () => `/Scheduler/CanPublish`,
  publish: () => `/Scheduler/Publish`,
}

const surveytag = {
  surveyTags: (id, ctype) => `/surveytag?id=${id}&customertype=${ctype}`,
}

const artifact = {
  get: src => `/Artifact/download?fileName=${src}`,
  post: () => `/Artifact`,
}
const surveyQuestion = {
  post: () => `/surveyquestion`,
  addSurveyQuestionList: () => `/surveyquestion/AddSurveyQuestionList`,
  put: () => `/surveyquestion`,
  delete: (id, surveyId) => `/surveyquestion?id=${id}&&surveyId=${surveyId}`,
  get: id => `/surveyquestion?id=${id}`,
  getByToken: () => `/surveyquestion/GetSurveyQuestionsBySurveyToken`,
  addSurveyQuestion: () => `/surveyquestion/AddSurveyQuestion`,
  addSurveyQuestionRemoveTempId: (surveyId, replaceQdId, newQid, order) =>
    `/surveyquestion/AddSurveyQuestionRemoveTempId?surveyId=${surveyId}&replaceQdId=${replaceQdId}&newQid=${newQid}&order=${order}`,
  reorderSurveyQuestions: (f, t, fIdx, tIdx, surveyId) =>
    `/SurveyQuestion/ReorderSurveyQuestions?fromId=${f}&toId=${t}&fromIndex=${fIdx}&toIndex=${tIdx}&surveyId=${surveyId}`,
}

const participants = {
  getSchoolsByMatId: matId => `/Participants/GetMatSchools?id=${matId}`,
  getStudentParent: () => 'Participants/GetStudentParantFromPm',
  getStaff: () => 'Participants/GetStaffFromPm',
  getStaffByFilter: () => 'Participants/GetStaffByFilter',
  getStudentByFilter: () => 'Participants/getStudentByFilter',
  getParentByFilter: () => 'Participants/getParentByFilter',
  checkPasscode: () => 'Participants/CheckPasscode',
  qrCodeVerify: () => 'Participants/QrCodeVerify',
  haveAllStudentEmails: (schoolId, matId) =>
    `Participants/HaveAllStudentEmails?schoolId=${schoolId}&matId=${matId}`,
  getParticipantFilters: (
    schoolId,
    matId,
    needStaffFilter,
    needStudentFilter,
    needParentFilter
  ) =>
    `/Participants/GetParticipantFilters?schoolId=${schoolId}&matId=${matId}&needStaffFilter=${needStaffFilter}&needStudentFilter=${needStudentFilter}&needParentFilter=${needParentFilter}`,

  getStaffStudentParentCount: () => 'Participants/GetStaffStudentParentCount',
}

const groupCycles = {
  post: () => `/groupCycle`,
  getBySurveyToken: () => `/groupCycle/getBySurveyToken`,
  CloseGroupCycleById: id => `/groupCycle/CloseGroupCycleById?id=${id}`,
  getOverLappingCycles: () => `/groupCycle/getOverLappingCycles`,
}

const categories = {
  post: () => `/category`,
  get: () => `/category`,
}

const subcategory = {
  post: () => `/subcategory`,
  get: () => `/subcategory`,
}

const questions = {
  post: () => `/questions`,
  get: id => `/questions?id=${id}`,
  getBuilderCategories: (matId, schoolId, surveyId, search) =>
    `/Questions/Categories/for-builder?matId=${matId}&schoolId=${schoolId}${surveyId ? `&surveyId=${surveyId}` : ''}${search ? `&search=${encodeURIComponent(search)}` : ''}`,
  createCategory: () => `/Questions/Categories`,
  getBySubCatId: id => `/questions/getBySubCatId?id=${id}`,
  getQuestionForParticipants: l =>
    `/surveyquestion/GetSurveyQuestionByParticipantToken?lang=${l}`,
  getListByIds: () => `/questions/GetListByIds`,
  getAll: id => `/questions/getAll`,
  getQuestionsByTagId: (tagId, audience, isAdmin, name) =>
    `/questions/GetQuestionsByTagId?tagId=${tagId}&audience=${audience}&isAdmin=${isAdmin}&name=${name}`,
  getQuestionsByTagIdAndSearch: (search, audience, isAdmin) =>
    `/questions/GetQuestionsByTagIdAndSearch?search=${search}&audience=${audience}&isAdmin=${isAdmin}`,
  getSurveyQuestionsByTagId: (schoolId, matId, tagId, audience) =>
    `/SurveyQuestion/GetSurveyQuestionsByTagId?schoolId=${schoolId}&matId=${matId}&tagId=${tagId}&audience=${audience}`,
}

// Organisation-scoped, reusable custom Likert scales.
const customLikertScales = {
  getForBuilder: (matId, schoolId, search) =>
    `/CustomLikertScales?matId=${matId}&schoolId=${schoolId}${search ? `&search=${encodeURIComponent(search)}` : ''}`,
  create: () => `/CustomLikertScales`,
  delete: (id, matId, schoolId) =>
    `/CustomLikertScales?id=${id}&matId=${matId}&schoolId=${schoolId}`,
}

const surveyTemplates = {
  get: (customerId, customerType) =>
    `/surveytemplates?id=${customerId}&customerType=${customerType}`,

  copyTemplate: (
    customerId,
    customerType,
    templateId,
    anonym,
    shared,
    audience,
    matId,
    schoolMatName
  ) =>
    `/surveytemplates/CopyTemplate?id=${customerId}&customerType=${customerType}&templateId=${templateId}&anonym=${anonym}&shared=${shared}&audience=${audience}&matid=${matId}&name=${schoolMatName}`,
}

const comments = {
  get: (surveyId, questionId, schoolId) =>
    `/SurveyComments?surveyId=${surveyId}&questionId=${questionId}&schoolId=${schoolId}`,
  getCommenterName: id => `/SurveyComments/GetCommenterName?id=${id}`,
  AddCommentReply: () => `/SurveyComments/AddCommentReply`,
  GetRepliesByCommentId: id => `/SurveyComments/GetRepliesByCommentId?id=${id}`,
}

const tags = {
  get: () => `/tags`,
  getTagsByAudience: (audience, s, m) =>
    `/tags/GetTagsByAudience?audience=${audience}&schoolId=${s}&matId=${m}`,
  tagQuestions: () => `/tags/tagQuestions`,
}

const emailTemplates = {
  get: (schoolId, matId, audience, surveyId) =>
    `/emailTemplates?schoolId=${schoolId}&matId=${matId}&audience=${audience}&surveyId=${surveyId}`,
  post: () => `/emailTemplates`,
  put: () => `/emailTemplates`,
  delete: id => `/emailTemplates?id=${id}`,
}

const customerService = {
  customerInfo: `Account/GetUserDetails`,
}

// Admin API: trust/school default logos (set on the home Themes > Logos screen).
const themeLogo = {
  getMatDefaultLogo: id => `/MatGroup/GetMatDefaultLogoForTheme?id=${id}`,
  getSchoolDefaultLogo: id => `/School/GetSchoolDefaultLogoForTheme?id=${id}`,
}

// School product endpoints using relative paths
const schoolProduct = {
  get: (schoolId, matId) => `/SchoolProducts/GetSchoolMatProducts`,
  requestProduct: (school, product) => `/SchoolProducts/RequestProduct`,
  hasPulseSurvey: (schoolId, matId) => `/surveys/haspulsesurvey`,
}

const checkin = {
  get: (matId, schoolId) => `/CheckIn?schoolId=${schoolId}&matId=${matId}`,
  getById: id => `/CheckIn/GetById?id=${id}`,
  getAll: () => `/CheckIn/getall`,
  post: () => `/CheckIn`,
  getList: id => `/CheckIn/GetCheckIncycles?id=${id}`,
  getListDetail: id => `/CheckIn/GetCheckInCycleDetails?id=${id}`,
  pause: id => `/CheckIn/Pause?id=${id}`,
  resume: id => `/CheckIn/Resume?id=${id}`,
  stop: id => `/CheckIn/Stop?id=${id}`,
  participationBySchool: id => `/CheckIn/ParticipationBySchool?id=${id}`,
  inviteReadiness: () => `/CheckIn/InviteReadiness`,
  templateQuestions: id => `/CheckIn/TemplateQuestions?id=${id}`,
}

const textToSpeech = {
  getQuestionTextToSpeech: () => '/SurveyQuestion/TextToSpeech',
  getWelcomeTextToSpeech: () => '/SurveyQuestion/WelcomeTextToSpeech',
}
const pupilFilter = {
  post: () => `/SafeSpaceStudent/GetStudentFilterOptions`,
  count: () => `/participants/GetStaffStudentParentCount`,
  list: () => `/SafeSpaceStudent/FilterStudents`,
}

const kiosk = {
  getSchoolInfo: (schoolSlug) => `/Kiosk/school/${schoolSlug}/info`,
  verifyURN: (schoolSlug) => `/Kiosk/school/${schoolSlug}/verify-urn`,
  searchStudents: (schoolSlug, query) => `/Kiosk/school/${schoolSlug}/students/search?query=${encodeURIComponent(query)}`,
  searchParents: (schoolSlug, query) => `/Kiosk/school/${schoolSlug}/parents/search?query=${encodeURIComponent(query)}`,
  verifyStudent: () => `/Kiosk/verify-student`,
  verifyParent: () => `/Kiosk/verify-parent`,
  getStudentSurveys: (schoolSlug, studentId) => `/Kiosk/school/${schoolSlug}/student/${studentId}/surveys`,
  getParentSurveys: (schoolSlug, childId) => `/Kiosk/school/${schoolSlug}/parent/${childId}/surveys`,
  getKioskSettings: (schoolId) => `/KioskAdmin/school/${schoolId}/settings`,
  getKioskStatus: (schoolId) => `/KioskAdmin/school/${schoolId}/status`,
  // Runtime mode select/exit happen on the public, unauthenticated kiosk device, so they use
  // the public slug-keyed Kiosk endpoints (not the scope-guarded, token-required KioskAdmin ones).
  setKioskMode: (schoolSlug) => `/Kiosk/school/${schoolSlug}/set-mode`,
  exitKiosk: (schoolSlug) => `/Kiosk/school/${schoolSlug}/exit-kiosk`,
}

export {
  artifact,
  comments,
  groupCycles,
  participants,
  questions,
  scheduler,
  survey,
  surveyQuestion,
  surveytag,
  surveyTemplates,
  tags,
  emailTemplates,
  schoolProduct,
  checkin,
  translation,
  themes,
  textToSpeech,
  pupilFilter,
  customerService,
  themeLogo,
  kiosk,
  customLikertScales,
}
